import "./YourLearning.css";
import { Link, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Lottie from "react-lottie";

import back from "../assets/Back.svg";
import filledBlueSpeech from "../assets/filledBlueSpeech.svg";
import share from "../assets/Share.svg";
import hollowFavourite from "../assets/hollowFavourite.svg";
import closeDropDown from "../assets/closeDropDown.svg";
import speech from "../assets/Speech.svg";
import close from "../assets/roundClose.svg";
import keyboad from "../assets/keyboard.svg";
import greenMic from "../assets/greenMic.svg";
import celebration from "../assets/celebration.svg";
import goodJob from "../assets/goodJob.svg";
import grayMic from "../assets/grayMic.svg";
import hollowSpeech from "../assets/hollowSpeech.svg";
import favourite from "../assets/Favourite.svg";
import Animation from "../assets/Animation.json";
import flower from "../assets/flower.svg";

import SpeechRecognition from "./SpeechRecognition";
import PopupMSG from "./PopupMSG";
import SpeakText from "./SpeakText";

export default function YourLearning() {
  const [showVisualizer, setShowVisualizer] = useState(false);
  const [bookmark, setBookMark] = useState(false);

  const [isMicClicked, setIsMicClicked] = useState(false);
  const [accuracy, setAccuracy] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [highlightedSyllables, setHighlightedSyllables] = useState([]);
  const [currentWord, setCurrentWord] = useState({
    Associated_Brands: "RESYNC EYE DROP 10ML, RESYNC EYE DROPS 5ML",
    Common_Usage: "Used in artificial tears for dry eye relief.",
    Definition: "A lubricant that retains moisture in the eye.",
    Mode_of_Action:
      "Forms a protective, hydrating layer on the ocular surface.",
    Molecule_Name: "Sodium Hyaluronate",
    Vocab_Breakdown: "So-di-um Hy-a-lu-ro-nate",
    favourite: false,
    id: 1,
  });
  const [isNextEnabled, setIsNextEnabled] = useState(false);
  const location = useLocation();

  const { completedBrands } = location.state || [];
  const { completedMolecules } = location.state || [];
  const [inCompletedMoleculenames, setInCompletedMoleculenames] = useState([]);
  const [inCompletedBrandnames, setInCompletedBrandnames] = useState([]);
  const userId = sessionStorage.getItem("userId");

  const handleHollowSpeechClick = () => {
    // Toggle the visualizer and play/pause state together
    // setShowVisualizer(prev => !prev); // Toggle the visibility of the visualizer
    if (showVisualizer) {
      setShowVisualizer(false); // Stop the music if visualizer is being hidden
    } else {
      setShowVisualizer(true);
    }
  };

  const onSpeechEnd = () => {
    setShowVisualizer(false);
  };

  const startRecognition = () => {
    setIsMicClicked(true);
  };

  const resetMic = () => {
    setIsMicClicked(false); // Reset mic state after finishing recognition
  };

  const handleWordComplete = (isComplete, acc, highlight) => {
    if (highlight) setHighlightedSyllables(highlight);
    if (acc > 90) {
      setIsNextEnabled(true);
    }
    if (isComplete) {
      setShowPopup(true);
      setAccuracy(acc);
      setTimeout(() => {
        setShowPopup(false);
        setIsMicClicked(false);
        setHighlightedSyllables([]);
      }, 8000);
    } else if (isComplete === null) {
      setIsMicClicked(false);
    }
  };

  useEffect(() => {
    let molecule_id = null;
    if (completedMolecules && completedMolecules.length > 0) {
        completedMolecules.forEach((item) => {
        molecule_id = item.id;
      });
    } else {
      molecule_id = 0; // or any other default value you want to assign
    }


    let brand_id = null; // default value

    if (completedBrands && completedBrands.length > 0) {
      completedBrands.forEach((item) => {
        brand_id = item.id;
      });
    } else {
      brand_id = 0; // or any other default value you want to assign
    }
    const fetchData = async () => {
      try {
        const [moleculeRes, brandRes] = await Promise.all([
          fetch(
            `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/molecules/${
              molecule_id + 1
            }?userId=${userId}`,
            {
              method: "GET",
              headers: {
                authorization: `bearer ${sessionStorage.getItem("token")}`,
              },
            }
          ),
          fetch(
            `https://alembicdigilabs.in/medicaldictionary/v1/eyecare/brands/${
              brand_id + 1
            }?userId=${userId}`,
            {
              method: "GET",
              headers: {
                authorization: `bearer ${sessionStorage.getItem("token")}`,
              },
            }
          ),
        ]);

        const moleculeData = await moleculeRes.json();
        const brandData = await brandRes.json();

        const allMolecules = moleculeData.molecules;
        const allBrands = brandData.brands;

        localStorage.setItem("moleculeItems", JSON.stringify(allMolecules));
        localStorage.setItem("brandItems", JSON.stringify(allBrands));

        // Filter incomplete molecules
        const completedMoleculeNames = completedMolecules.map((item) =>
          item.name.toLowerCase()
        );
        const incompleteMolecules = allMolecules.filter(
          (mol) =>
            !completedMoleculeNames.includes(mol.Molecule_Name.toLowerCase())
        );
        setInCompletedMoleculenames(incompleteMolecules);

        // Filter incomplete brands
        const completedBrandNames = completedBrands.map((item) =>
          item.name.toLowerCase()
        );
        const incompleteBrands = allBrands.filter(
          (brand) => !completedBrandNames.includes(brand.Brand.toLowerCase())
        );
        setInCompletedBrandnames(incompleteBrands);

        // Set first incomplete word (molecule takes priority)
        if (incompleteMolecules.length > 0) {
          setCurrentWord(incompleteMolecules[0]);
        }
        // else if (incompleteBrands.length > 0) {
        //     setCurrentWord(incompleteBrands[0]);     //imortant to note that this line is commented out in the original code
        // }
        else {
          setCurrentWord(allMolecules[0]); // Fallback to first molecule if no incomplete words
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const addToBookmark = async () => {
    let data = {
      UserId: userId,
      Type: currentWord.Brand || currentWord.Name ? "Brand" : "Molecule",
      Vocab_Breakdown: currentWord.Vocab_Breakdown,
      Definition: currentWord.Definition,
      Mode_of_Action: currentWord.Mode_of_Action,
      Common_Usage: currentWord.Common_Usage,
      action: bookmark ? "delete" : "add",
    };
    
    if(currentWord.Brand || currentWord.Name){
        data["Brand_Name"] = currentWord.Brand_Name;
        data["Name"] = currentWord.Brand || currentWord.Name;
    } else {
        data["Associated_Brands"] = currentWord.Associated_Brands;
        data["Molecule_Name"] = currentWord.Molecule_Name;
    }
    const apiUrl =
      "https://alembicdigilabs.in/medicaldictionary/v1/eyecare/favourites";

    try {
      const response = await fetch(apiUrl, {
        method: "POST", // HTTP method
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${sessionStorage.getItem("token")}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const result = await response.json();
        setBookMark((prev) => !prev);
        console.log("Response:", result); // Log the response from the API
      } else {
        console.error("Error:", response.statusText); // Log any errors
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleNextClick = async () => {
    if (!currentWord) return;

    const apiUrl =
      "https://alembicdigilabs.in/medicaldictionary/v1/eyecare/progress";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `bearer ${sessionStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          word: currentWord.Molecule_Name || currentWord.Brand,
          user_id: userId,
          type: currentWord.Molecule_Name ? "Molecule" : "Brand",
          molecule_id: currentWord.id,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const res = await response.json();

      let nextWord = null;

      if (res?.brand_id || res?.molecule_id) {
        if (currentWord.Molecule_Name) {
          const remaining = inCompletedMoleculenames.slice(1);
          setInCompletedMoleculenames(remaining);
          nextWord = remaining[0];
        } else {
          const remaining = inCompletedBrandnames.slice(1);
          setInCompletedBrandnames(remaining);
          nextWord = remaining[0];
        }

        setCurrentWord(nextWord);
        setIsNextEnabled(false); // Reset Next button
      } else {
        alert("🎉 All words completed or skipped!");
      }
    } catch (error) {
      console.error("Error in progress API:", error);
      alert(
        "Something went wrong while saving your progress. Please try again."
      );
    }
  };

  const handleSkipClick = () => {
    let nextWord = null;

    if (currentWord?.Molecule_Name) {
      const remaining = inCompletedMoleculenames.slice(1);
      setInCompletedMoleculenames(remaining);
      nextWord = remaining[0];
    } else {
      const remaining = inCompletedBrandnames.slice(1);
      setInCompletedBrandnames(remaining);
      nextWord = remaining[0];
    }

    if (nextWord) {
      setCurrentWord(nextWord);
      setIsNextEnabled(false); // Reset next button for next word
    } else {
      // setCurrentWord(null);
      alert("🎉 All words completed or skipped!");
    }
  };

  const defaultOptions = {
    loop: true, // Whether the animation should loop or not
    autoplay: true, // Whether the animation should start playing automatically
    animationData: Animation, // The JSON data for the animation
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice", // Adjust how the animation scales
    },
  };

  return (
    <div className="dictionary-container">
      {/* Header */}
      <header className="text-left py-3 d-flex gap-3">
        <Link to="/home" className="text-decoration-none align-self-center">
          <img src={back} alt="Back" className="dictionary-icon mb-3" />
        </Link>
        <p className="dictionaryHeader">Your Learning</p>
      </header>
      <div className="p-2">
        <p className="mb-0 fs-2">{currentWord.Molecule_Name}</p>
        {showVisualizer && (
          <SpeakText
            textToSpeak={currentWord.Molecule_Name}
            speechRate={"0.7"}
            onSpeechEnd={onSpeechEnd}
          />
        )}
        <div className="mt-3 d-flex yourLearningActionIcon">
          <img
            src={!showVisualizer ? hollowSpeech : filledBlueSpeech}
            alt="speech"
            className="col-md-4 w-75"
            onClick={handleHollowSpeechClick}
          />
          <img src={share} alt="share" className="col-md-4 w-75" />
          <img
            src={bookmark ? favourite : hollowFavourite}
            alt="bookmark"
            className="col-md-4 w-75"
            onClick={addToBookmark}
          />
          <img src={closeDropDown} alt="hide" className="col-md-4 w-75" />
        </div>
        <div className="vocab-breakdown mt-4 px-3">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ borderBottom: "2px solid rgba(218, 223, 230, 1)" }}
          >
            <span className="fs-12">Vocab Breakdown:</span>
            <img src={speech} alt="speaker" />
          </div>
          <span
            style={{
              placeContent: "center",
              textAlign: "center",
              fontStyle: "italic",
              fontSize: "16px",
            }}
          >
            {currentWord.Vocab_Breakdown.split("-").map((syllable, index) => (
              <span
                key={index}
                style={{
                  color: highlightedSyllables.includes(syllable)
                    ? "rgba(57, 63, 73, 1)"
                    : "",
                }}
              >
                {syllable}
                {index < currentWord.Vocab_Breakdown.split("-").length - 1 &&
                  "-"}
              </span>
            ))}
          </span>
        </div>

        {isMicClicked && (
          <>
            <SpeechRecognition
              word={{
                name: currentWord.Molecule_Name
                  ? currentWord.Molecule_Name
                  : currentWord.Brand,
                syllables: currentWord.Vocab_Breakdown,
              }} // Passing only one word at a time
              onWordComplete={handleWordComplete} // Callback to handle word completion
            />
            <div className="speechAnimatin">
              <Lottie options={defaultOptions} height={200} width={150} />
            </div>

            <div
              style={{
                placeContent: "center",
                textAlign: "center",
                fontStyle: "italic",
                fontSize: "28px",
              }}
            >
              {currentWord.Vocab_Breakdown.split("-").map((syllable, index) => (
                <span
                  key={index}
                  style={{
                    color: highlightedSyllables.includes(syllable)
                      ? "rgba(29, 180, 105, 1)"
                      : "rgba(218, 223, 230, 1)",
                  }}
                >
                  {syllable}
                  {index < currentWord.Vocab_Breakdown.split("-").length - 1 &&
                    "-"}
                </span>
              ))}
            </div>
          </>
        )}

        <div className="d-flex justify-content-around mt-4">
          <img src={keyboad} alt="close" className="keybord" />
          <img
            src={isMicClicked ? grayMic : greenMic}
            alt="close"
            className="mic"
            onClick={startRecognition}
          />
          <img src={close} alt="close" className="close" onClick={resetMic} />
        </div>
        <div className="d-flex flex-column gap-3 mt-5">
          <div
            className={`d-flex justify-content-center align-items-center rounded-3 yourLearningNext ${
              !isNextEnabled ? "disabled-next" : "modify-next"
            }`}
            onClick={isNextEnabled ? handleNextClick : undefined}
          >
            Next
          </div>
          <div
            className="d-flex justify-content-center align-items-center rounded-3 skiplabel"
            onClick={handleSkipClick}
          >
            Skip the Word
          </div>
        </div>
      </div>

      {showPopup && (
        <PopupMSG
          icon={
            accuracy >= 90 ? celebration : accuracy >= 50 ? goodJob : flower
          }
          message={
            accuracy >= 90
              ? `Great job! You were ${accuracy}% accurate with your pronunciation. 
          Keep up the excellent work!`
              : accuracy >= 50
              ? `Nice effort! You were ${accuracy}% accurate with your pronunciation. 
          Clear your throat and give it another go to boost your accuracy!`
              : `Keep practicing! Your accuracy was ${accuracy}%, 
          but don't worry, use the app regularly to refine your pronunciation and improve your score.`
          }
          title={
            accuracy >= 90
              ? "Congratulations!"
              : accuracy >= 50
              ? "Good Attempt!"
              : "Good Luck Next Time!"
          }
        />
      )}
    </div>
  );
}
